//export const Api = window.location.origin+"/api/";
//export const Api = "http://localhost:32214/api/";
//export const Api = "http://localhost:5145/api/";
export const Api = "http://apatech-001-site4.ntempurl.com/api/";



//import { useContext, useState, useEffect } from "react";
//export const Api=()=> {
//const [data, setData] = useState('');

//useEffect(() => {
//    fetch('/api.txt')
//        .then((response) => response.text())
//        .then((text) => {
//            setData(text);
//        })
//        .catch((error) => console.error('Error al leer el archivo:', error));
//}, []);
//    return data;
//}